/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Delete_LastInputs */

const cs_settings_venues_delete_last = /** @type {(inputs: Settings_Venues_Delete_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toto je jediná pobočka. Než ji smažete, založte jinou.`)
};

const en_settings_venues_delete_last = /** @type {(inputs: Settings_Venues_Delete_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the only venue. Create another before deleting it.`)
};

/**
* | output |
* | --- |
* | "This is the only venue. Create another before deleting it." |
*
* @param {Settings_Venues_Delete_LastInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_delete_last = /** @type {((inputs?: Settings_Venues_Delete_LastInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Delete_LastInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_delete_last(inputs)
	return cs_settings_venues_delete_last(inputs)
});